import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useMenu } from "../../hooks/useMenu";
import { ActionIconItem } from "./ActionIconItem";
import { resolveActionConfig } from "../../helpers/configResolver";

export const Navigation = ({ item, data, height = 25, companyInfo = {} }) => {
    const navigate = useNavigate();
    const [idConfiguration, setIdConfiguration] = useState(true);

    const [menuList] = useMenu();
    const {
        menu
    } = menuList;

    const handleRedirect = (actionItem) => {
        const resolvedAction = resolveActionConfig(actionItem, data, companyInfo);
        const path = resolvedAction?.config?.path || '';
        const id_user_action = resolvedAction?.config?.id_user_action || '';
        const id = data?.id;
        const id_flow_process = data?.id_flow_process;

        let userConfig = null;
        let nameConfig = null;
        if (id_user_action) {
            menu.forEach((menuItem) => {
                if (menuItem.id_user_action === id_user_action) {
                    userConfig = menuItem.configuration;
                    nameConfig = menuItem.name;
                }
            });
            setIdConfiguration(true);
        }
        const rowPayload = {
            ...data,
            id_user_action: id_user_action || '',
            work_flow: resolvedAction?.work_flow || actionItem.work_flow || ''
        };
        const navigationState = {
            config: { ...(resolvedAction?.config || {}), data: rowPayload },
            configuration: userConfig || '',
            title: nameConfig || ''
        };
        if (path.includes('flow-')) {
            navigate(`${path}${id}`, { state: { config: { id, data: rowPayload } } });
            return
        }
        if (id && id_flow_process == null && !path.includes('invoice') && !path.includes('companies')
            && !path.includes('configuration') && !path.includes('provider') && !idConfiguration) {
            navigate(`${path}${id}`, { state: { config: { id, data: rowPayload } } });
        }
        else {
            navigate(`${path}`, { state: navigationState });
        }
    };

    return (
        <ActionIconItem
            item={item}
            onClick={(itemData) => handleRedirect(itemData)}
            height={height}
        />
    )
};
